var call = 1;
var uuid = function uuid() {
  var now = new Date();
  var time = now.getTime() + (call += 1);
  var sTime = time.toString();
  var rTime = sTime.split('').reverse().join('');
  return "".concat(sTime).concat(rTime).concat(sTime).substring(0, 36);
};
module.exports = uuid;